//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axiosApi from '@/request/index'
import bottom from '@/assets/img/bottom.png'
import {getUrlparams, countDownTimeFunc, toCopy} from '@/utils/util.js'
import footerNav from '@/components/footerNav'
import {Dialog, Toast} from 'vant';

export default {
  name: "qualityOrder",
  components: {
    footerNav
  },
  data() {
    return {
      bottom,
      showPopup: false,
      value: '',
      toCopy,
      searchValue: '',
      loading: false,
      finished: false,
      refreshing: false,
      someQualityOrderList: [],
      list: [],
      checkAll: false,
    }
  },
  created() {
  },
  mounted() {
  },
  updated() {
    document.scrollingElement.scrollTop = 0
  },
  methods: {
    onSearch() {
      this.someQualityOrderList = [];
      this.onLoad()
    },
    onLoad() {
      // getSendOrderList
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      var params = {
        'searchValue': this.searchValue,
        "qualityOrderType": 1,
        "start": this.someQualityOrderList.length,
        "size": 10,
        "orderRules": [{"orderKey": "recTime", "desc": true}, {"orderKey": "qualityOrderId", "desc": true}],
        "desc": true
      }
      axiosApi.querySpotcheckList(params).then(response => {
        if (response.content && response.content.list && response.content.list.length > 0) {
          response.content.list.forEach((item) => {
            var channelStr = '';
            if (item.firstDeptName) {
              channelStr += item.firstDeptName
            }
            if (item.secondDeptName) {
              channelStr += '/' + item.secondDeptName
            }
            item.channelStr = channelStr
            if (item.isStockIn == 1) {
              item.isStockInStr = '是'
            }
            if (item.isStockIn == 0) {
              item.isStockInStr = '否'
            }
            if (item.isRedone == 1) {
              item.isRedoneStr = '是'
            }
            if (item.isRedone == 0) {
              item.isRedoneStr = '否'
            }
            if (item.qualityOrderDetailList && item.qualityOrderDetailList.length > 0) {
              item.qualityOrderDetailList.forEach((item) => {
                item.choose = false
              })
            }
          })
          this.someQualityOrderList = this.someQualityOrderList.concat(response.content.list)
        }
        this.loading = false;
        this.refreshing = false;
        if (this.someQualityOrderList.length == response.content.total) {
          this.finished = true;
        }
      })
    },
    toSome(row) {
      this.$router.push({name: 'someQualityDetail', query: {data: JSON.stringify(row)}})
    },
    toDetail() {
      this.$router.push({name: 'qualityOrderDetail'})
    },
    showCheck(item) {
      if (item.qualityResultId) {
        this.$router.push({
          name: 'qualityWrite',
          query: {qualityResultId: item.qualityResultId, qualityOrderId: item.qualityOrderId}
        })
      } else if (item.qualityOrderDetailList.length == 1) {
        this.$router.push({name: 'qualityWrite', query: {data: JSON.stringify([item])}})
      } else if (item.qualityOrderDetailList.length > 1) {
        item.qualityOrderDetailList.forEach((item) => {
          item.choose = false
        })
        this.list = item.qualityOrderDetailList
        this.showPopup = true
      }
    },
    chooseConfirm() {
      var list = this.list.filter((item) => {
        return item.choose == true
      })
      if (list.length == 0) {
        Toast.fail('请选择');
        return
      } else {
        this.$router.push({name: 'qualityWrite', query: {data: JSON.stringify(list)}})
      }
    },
    chooseAll() {
      let a = this.checkAll;
      this.list = this.list.map(e => {
        e.choose = a;
        return e;
      });
    },
    choose() {
      let a = true;
      this.list.forEach(e => {
        if (e.choose === false) {
          a = false;
        }
      });
      console.log(a)
      this.checkAll = a;
    },
    clickBtn() {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作',
      })
        .then(() => {
          Toast.success('成功');

        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    toAudit(item) {
      this.$router.push({name: 'qualityAudit', query: {qualityOrderId: item.qualityOrderId}})
    },
    backSubmit(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作？',
      })
        .then(() => {
          var queryParams = {qualityOrderIdList: [item.qualityOrderId]}
          axiosApi.clearQualityOrderResult(queryParams).then(response => {
            Toast.success('操作成功');
            this.onSearch()
          }).catch(error => {
          })
        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    backAudit(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认进行此操作?如质检单采购审核已生成全检单或返工单,需操作作废!',
      })
        .then(() => {
          var queryParams = {qualityOrderIdList: [item.qualityOrderId]}
          axiosApi.unAuditQuality(queryParams).then(response => {
            Toast.success('操作成功');
            this.onSearch()
          }).catch(error => {
          })
        })
        .catch(() => {
          Toast.fail('已取消');
        });
    },
    deleteRow(item) {
      Dialog.confirm({
        title: '提示',
        message: '确认作废？',
      }).then(() => {
        var queryParams = {qualityOrderStatus: -1, qualityOrderIdList: [item.qualityOrderId]}
        axiosApi.cancelQualityOrder(queryParams).then(response => {
          Toast.success('操作成功');
          this.onSearch()
        }).catch(error => {
        })
      }).catch(() => {
        Toast.fail('已取消');
      });
    },
    toReport(){
      this.$router.push({name: 'qualityReport'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/qualityOrder/index.vue